export const HEADCOUNT_PATH = '/line-up';
/** The page's address before it was renamed Line Up; links to it redirect. */
export const LEGACY_HEADCOUNT_PATH = '/headcount';

/** The Line Up address for a legacy /headcount address, keeping the tab and query string. */
export const fromLegacyPath = (pathname: string, search: string): string =>
  `${HEADCOUNT_PATH}${pathname.slice(LEGACY_HEADCOUNT_PATH.length)}${search}`;

export type HeadcountTabId = 'overview' | 'roster' | 'open' | 'targets' | 'cuts' | 'moves';

export const TAB_SLUGS: Record<HeadcountTabId, string> = {
  overview: 'overview',
  roster: 'roster',
  open: 'open-roles',
  targets: 'targets',
  cuts: 'cuts',
  moves: 'movements'
};

export const TAB_IDS = Object.keys(TAB_SLUGS) as HeadcountTabId[];
